import React from "react"
import { graphql, Link } from "gatsby"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import Layout from "@components/layout"

const StyledBlogContainer = styled.main`
  max-width: 1000px;

  ul {
    li {
      margin-bottom: 48px; /* Increased space between blog posts */
      font-size: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      h2 {
        margin: 0;
        font-size: inherit;

        a {
          color: var(--light-slate);
        }
      }

      .subtitle {
        color: var(--slate);
        font-size: var(--fz-sm);
      }
    }
  }
`

const BlogPage = ({ data, location }) => {
  const posts = data?.allMarkdownRemark?.edges || []

  return (
    <Layout location={location}>
      <Helmet title="Open Interval" />

      <StyledBlogContainer>
        <h1 className="big-heading">Open Interval</h1>

        {posts.length === 0 ? (
          <p>No posts published yet.</p>
        ) : (
          <ul className="fancy-list">
            {posts.map(({ node }) => {
              const { slug, title, date, description } = node.frontmatter
              return (
                <li key={slug}>
                  <h2>
                    <Link to={slug}>{title}</Link>
                  </h2>
                  <p className="subtitle">
                    <time>
                      {new Date(date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </time>
                  </p>
                  {description && <p>{description}</p>}
                </li>
              )
            })}
          </ul>
        )}
      </StyledBlogContainer>
    </Layout>
  )
}

BlogPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              slug: PropTypes.string.isRequired,
              title: PropTypes.string.isRequired,
              date: PropTypes.string.isRequired,
              description: PropTypes.string,
            }).isRequired,
          }).isRequired,
        })
      ),
    }),
  }).isRequired,
  location: PropTypes.object,
}

export default BlogPage

export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/posts/" }
        frontmatter: { draft: { ne: true } }
      }
      sort: { frontmatter: { date: DESC } }
    ) {
      edges {
        node {
          frontmatter {
            slug
            title
            date
            description
          }
        }
      }
    }
  }
`
